<template>
	<div class="calclist-package bg-white">
		<div class="calclist-box-title packageToggle">
			<span :class="['toggleArrow', !visible ? '' : 'open']" @click="toggle()">Kiegészítő csomagja</span>
		</div>
		<div v-if="visible" class="form">
			<ul class="d-flex w-100 extend-info">
				<li>
					<span><img src="/img/frontend/calc/icon/check.svg" alt="" /></span>
					= Tartalmazza az ajánlat
				</li>
				<li>
					<span><img src="/img/frontend/calc/icon/times.svg" alt="" /></span>
					= Nem tartalmazza az ajánlat
				</li>
				<li>
					<span>Aa</span>
					= Kiválasztott kiegészítők
				</li>
			</ul>
			<ul class="basic-package extend columns-2">
				<li
					v-for="(event, index) in computedInsuranceEvents"
					:key="index"
					class="label"
					:class="{ tick: event.includes, crossmark: !event.includes, 'fs-bold': event.isChecked }"
				>
					{{ event.name }}
					<span v-if="event.includes && event.fee">- {{ event.fee | toCurrency }}</span>
                    <div v-if="event.id === 22 && getValuableSum > 0">
                        Fedezeti összeg: {{ getValuableSum - 200000 | toCurrency }}
                    </div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';

export default {
	props: {
		offer: { type: Object, default: () => {} },
	},
	computed: {
		...mapGetters(['getSelectedInsuranceEvents', 'getInsuranceEvents', 'getValuableSum']),
		computedInsuranceEvents() {
			const events = _.cloneDeep(this.getInsuranceEvents.extend);
			let sorted = _.orderBy(events, event => this.getSelectedInsuranceEvents().includes(event.id), 'desc');

			_.each(sorted, event => {
				const iEvent = _.filter(this.offer.insurance_events, iEvent => iEvent.id === event.id);

				(event.includes = _.map(
					_.filter(this.offer.insurance_events, event => event.included),
					event => event.id,
				).includes(event.id)),
					(event.isChecked = this.getSelectedInsuranceEvents().includes(event.id));
				event.fee = iEvent.length > 0 ? iEvent[0].fee : null;
			});

			sorted = _.orderBy(sorted, event => event.includes, 'desc');

			return sorted;
		},
	},
	data() {
		return {
			visible: true,
		};
	},
	methods: {
		toggle() {
			this.visible = !this.visible;
		},
	},
};
</script>

<style lang="scss" scoped>
.extend-info {
	justify-content: center;
	align-items: center;
	padding: 0;
	margin: 0;

	@media screen and (max-width: 520px) {
		flex-direction: column;
	}

	li {
		list-style-type: none;
		padding: 5px 10px;
		color: #706f6f;
		font-size: 11px;
		line-height: 14px;

		span {
			font-weight: 700;
			color: black;

			img {
				width: 12px;
				height: 9px;
			}
		}
	}
}
</style>
